import { Page, View, StyleSheet, Text, Font } from "@react-pdf/renderer";
import srcTimes from "../../../assets/custom/font/times/times.ttf";
import srcTimesBold from "../../../assets/custom/font/times/timesbd.ttf";
import srcTimesItalic from "../../../assets/custom/font/times/timesi.ttf";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
// import qrCode from '../../../assets/images/qrcode.png'

Font.register({ family: "Times", src: srcTimes });
Font.register({ family: "TimesBold", src: srcTimesBold });
Font.register({ family: "TimesItalic", src: srcTimesItalic });

// Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box",
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 189,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto",
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1,
    },
    text: {
        fontSize: 10,
        fontFamily: "Times",
    },
    textBold: {
        fontSize: 12,
        fontFamily: "TimesBold",
    },
    textItalic: {
        fontSize: 12,
        fontFamily: "TimesItalic",
    },
    footer: {
        position: "absolute",
        paddingHorizontal: 42,
        bottom: 80,
        left: 0,
        right: 0,
        height: 80,
        textAlign: "center",
        // color: "grey",
        fontSize: 9,
        fontFamily: "Times",
    },
});

const DraftAppendix = ({ ppmdetil, datahc, upt, dataDisposisi, qrImage }) => {
    return (
        // <Document>
        <Page size="A4" orientation="portrait" style={styles.page}>
            {/* top Appendix */}
            <View style={[styles.table]}>
                <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, { width: "85%", alignItems: "left" }]}>
                        <View style={[styles.table, { marginBottom: 3, marginTop: 5 }]}>
                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left", marginBottom: 16 }]}>
                                        Appendix :
                                    </Text>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        Certificate of Quality And Safety For Fish And Fishery Product
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.table]}>
                            <View style={[styles.tableRow, { marginBottom: 3 },]}>
                                <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        Submission No.
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        {datahc !== null ? datahc.trHcMutuPK.nomorAju : ''}
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        Certificate No.
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "25%", alignItems: "left" }]}>
                                    <Text style={[styles.textBold, { fontSize: 12, textAlign: "Left" }]}>
                                        {datahc !== null ? datahc.noHcMutu : ''}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableCol, { width: "15%", alignItems: "center" }]}>
                        {/* <Image style={styles.headingImg} src={qrCode} /> */}
                        {/* <Image src={qrImage} style={{ width: 60, height: 60 }} /> */}
                    </View>
                </View>
            </View>
            {/* judul & SN */}
            <View style={[styles.table, { marginBottom: 3, marginTop: 15 }]}>
                <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, { width: "15%", alignItems: "center" }]}>
                        <Text style={[styles.textBold, { fontSize: 12, textAlign: "center" }]}>

                        </Text>
                    </View>
                    <View style={[styles.tableCol, { width: "70%", alignItems: "center" }]}>
                        <Text style={[styles.textBold, { fontSize: 12, textAlign: "center" }]}>
                            DESCRIPTION ON THE CONSIGMENT
                        </Text>
                    </View>
                    <View style={[styles.tableCol, { width: "15%", alignItems: "center" }]}>
                        <Text style={[styles.textBold, { fontSize: 11, textAlign: "center" }]}>
                            SN : {datahc !== null ? datahc.noSeriMutu : ''}
                        </Text>
                    </View>
                </View>
            </View>
            {/* header tabel apendix */}
            <View style={[styles.table, { marginTop: 15 }]}>
                <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                        <Text style={[styles.text, { fontSize: 10, textAlign: "left" }]}>
                            Name and Quantity of the Product:
                        </Text>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                    <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                        <Text style={[styles.text, { fontSize: 11, textAlign: "center", paddingTop: 9 }]}>
                            No.
                        </Text>
                    </View>
                    <View style={[styles.tableCol, { width: "70%", alignItems: "center", borderRightWidth: 1 }]}>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                    FISH / FISH PRODUCT
                                </Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                    Latin Name
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                    Common Name
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableCol, { width: "25%", alignItems: "center" }]}>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                    QUANTITY
                                </Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow]}>
                            <View style={[styles.tableCol, { width: "100%", alignItems: "center", borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                    (hds/pce/kgm/grm/ltr/mlt)
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            {/* Detail Appendix */}
            {
                ppmdetil.map((detil, index) => {
                    return (
                        <View key={index} style={[styles.table]}>
                            <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <View style={[styles.tableCol, { width: "5%", alignItems: "left", borderRightWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: "right", paddingRight: 5 }]}>
                                        {detil.trPpkDtlPK.seri}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "35%", alignItems: "left", borderRightWidth: 1 }]}>
                                    <Text style={[styles.textItalic, { fontSize: 10, textAlign: "left", paddingLeft: 5 }]}>
                                        {detil.namaLatin}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "35%", alignItems: "left", borderRightWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: "left", paddingLeft: 5 }]}>
                                        {detil.namaLokal}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "15%", alignItems: "right" }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: "right", paddingRight: 5 }]}>
                                        {detil.jumlah}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "10%", alignItems: "left" }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: "left" }]}>
                                        {detil.kodeSatuan}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    )
                })
            }
            <View style={styles.footer}>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "30%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: "left" }]}>{upt !== null ? upt.kota : '-'}, {datahc !== null ? formatDateStringLocalDate(datahc.tglHc) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "30%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: "left" }]}>{upt !== null ? upt.nmInggris : '-'}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "40%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "30%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>{dataDisposisi.nmPejabat}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "18%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "30%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>NIP. {dataDisposisi.nipPejabat}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </Page>
        // </Document>
    );
};

export default DraftAppendix;
